import { render, staticRenderFns } from "./ChartsPage.vue?vue&type=template&id=01ceee70&"
import script from "./ChartsPage.vue?vue&type=script&lang=js&"
export * from "./ChartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports